import { render, staticRenderFns } from "./MiPerfil.vue?vue&type=template&id=2127106a&scoped=true&"
import script from "./MiPerfil.vue?vue&type=script&lang=ts&"
export * from "./MiPerfil.vue?vue&type=script&lang=ts&"
import style0 from "./MiPerfil.vue?vue&type=style&index=0&id=2127106a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2127106a",
  null
  
)

export default component.exports